import Image from "next/image";

import Rating from "~/componentsND/Rating";
import Paragraph from "~/componentsDS/Typography/Paragraph";
import Overline from "~/componentsDS/Typography/Overline";
import { cn } from "~/lib/utils";
import { TRUSTED_BY_AVATARS } from "~/data/trustedByAvatars";

type Props = {
    className?: string;
};

export const StarRating = ({ className }: Props) => {
    return (
        <div className={cn("flex items-center gap-2 text-primary300", className)}>
            <Image {...TRUSTED_BY_AVATARS} alt="" />

            <div>
                <div className="flex items-center gap-1">
                    <Rating rating={5} className="text-inherit" />
                    <Paragraph size="sm" weight="500" className=" leading-none pt-1">4.9/5</Paragraph>
                </div>
                <Overline weight="500" className="max-md:text-[12px] leading-[1.33] uppercase mt-1">Trusted by 100,000+ women</Overline>
            </div>
        </div>
    );
};

export default StarRating;
